/* eslint-disable camelcase */
import React from 'react'
import Routers from './routers/router'
import { QueryClient, QueryClientProvider} from 'react-query'
import { UserProvider } from './shared/contexts/role-context'
import { AuthContextProvider } from './shared/contexts/AuthContextProvider'
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import LoginPage from './login'

const queryClient = new QueryClient()
function App () {
  
  return (
    <>
     <AuthenticatedTemplate>
     <AuthContextProvider>
      <QueryClientProvider client={queryClient}>
       {/* <UserProvider> */}
       <Routers />
       {/* </UserProvider> */}
        {/* <UserDetails/> 
        <RoleDetails/>  */}
        </QueryClientProvider>
        </AuthContextProvider>
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
        <LoginPage />
    </UnauthenticatedTemplate>
        </>
  )
}
export default App
